import React from 'react'

import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import {useUserContext} from "../../../contexts/UserContext";

import _ from 'lodash'
import {useNavigate} from "react-router";
import {useState} from "react";

import {buildStyleDescriptionName} from "../../../utils/utils";
import {CreatePricingSectionMobile} from "./CreatePricingSectionMobile";

import './PricingListPageMobile.scss'
import {usePricingsStore} from "../../../stores/pricingsStore";
import {useShallow} from "zustand/react/shallow";
import {PricingListPricing} from "../PricingListTable";

const initialState = {
    year: '',
    model: null,
    trim: null,
    base_car: null
}


export const PricingListPageMobile = ( { make } ) => {
    const [state, setState] = useState(initialState)
    const { profileState } = useUserContext()
    const {
        pricingData,
        isLoading,
    } = usePricingsStore(
        useShallow((state) => ({
            pricingData: state.pricingData,
            isLoading: state.isLoading,
        }))
    )
    const navigate = useNavigate();

    const handleMakeChange = (make) => {
        setState(initialState)
        navigate(`/pricing/${make}`)
    }

    const years = Object.keys(pricingData)
    const models = Boolean(state.year.length) ? Object.keys(pricingData[state.year]) : []
    const trims = Boolean(state.year.length && state.model.length) ? pricingData[state.year][state.model] : []
    const pricings = Boolean(state.trim) ? state.trim.pricings : []

    return (
        <Box id={"PricingListPageMobile"}>
            <Box className={'PricingListPageMobile_select-car'}>
                <h3>
                    Pricing Index
                </h3>
                <Box className={'select-rows-container'}>

                <div className={'select-row'}>
                    <label>Year</label>
                    <Select
                        disabled={isLoading}
                        className={'PricingListPageMobile-Select'}
                        labelId="pricing-select-year"
                        id="year-select"
                        value={state.year}
                        label="Year"
                        onChange={(e) => setState({...state, year: e.target.value, model: null, trim: {}})}
                    >
                        {
                            years.map((year) => <MenuItem key={year} value={year}>{year}</MenuItem>)
                        }
                    </Select>
                </div>
                <div className={'select-row'}>
                    <label>Brand</label>
                    <Select
                        disabled={isLoading}
                        className={'PricingListPageMobile-Select'}
                        labelId="pricing-select-make"
                        id="make-select"
                        value={make}
                        label="Make"
                        onChange={(e) => handleMakeChange(e.target.value)}
                    >
                        {
                            profileState?.makes_list.map((make) => <MenuItem key={make} value={make}>{make}</MenuItem>)
                        }
                    </Select>
                </div>
                <div className={'select-row'}>
                    <label>Model</label>
                    <Select
                        disabled={isLoading || !state.year}
                        className={'PricingListPageMobile-Select'}
                        labelId="pricing-select-model"
                        id="model-select"
                        value={state.model}
                        label="Model"
                        onChange={(e) => setState({...state, model: e.target.value, sd: null})}
                    >
                        {
                            models.map((model) => <MenuItem key={model} value={model}>{model}</MenuItem>)
                        }
                    </Select>
                </div>
                <div className={'select-row'}>
                    <label>Trim</label>
                    <Select
                        disabled={isLoading || !state.model}
                        className={'PricingListPageMobile-Select trim-select'}
                        labelId="pricing-select-trim"
                        id="trim-select"
                        value={state.trim}
                        label="Trim"
                        onChange={(e) => setState({...state, trim: e.target.value })}
                    >
                        {
                            trims.map((trim) =><MenuItem key={trim.id} value={trim}>{trim.name}</MenuItem>)
                        }
                    </Select>
                </div>
            </Box>
            </Box>
            {
                pricings.map((pricing) => (
                    <PricingListPricing
                        key={pricing.id}
                        pricing={pricing}
                        trim={state.trim}
                        year={state.year}
                    />
                ))
            }
            {
                state.sd &&
                <CreatePricingSectionMobile style_description={state.sd}/>
            }
        </Box>
    )
}